import { defineStore } from "pinia";

export const useLocaleStore = defineStore("locale", () => {
  const availableLocales = ["en", "fr"];

  function getPreferedLanguage() {
    const preferedLanguages = window.navigator.languages;
    for (let lang of preferedLanguages) {
      let short = lang.slice(0, 2);
      if (availableLocales.includes(short)) return short;
    }
    return availableLocales[0];
  }

  /** @type {Ref<string>} */
  const locale = ref(getPreferedLanguage());

  // TODO : update user locale if logged in and different
  return { locale, getPreferedLanguage, availableLocales };
});
